import { useState } from 'react';
import { useStore } from 'hooks';
import { message } from 'components/ui';

type UseSuggestedPhoneParams = {
  isPhoneInList: (phoneDigits: string) => boolean;
  persistNewPhone: (phoneDigits: string) => Promise<any>;
};

export const useSuggestedPhone = ({
  isPhoneInList,
  persistNewPhone,
}: UseSuggestedPhoneParams) => {
  const { createRequest } = useStore();
  const [suggestedPending, setSuggestedPending] = useState<boolean>(false);

  const suggestedPhoneDigits = createRequest.lastValidPhoneNumber;
  const showSuggestedPhone =
    suggestedPhoneDigits.length === 10 && !isPhoneInList(suggestedPhoneDigits);

  const addSuggestedPhone = async () => {
    if (suggestedPending) {
      return;
    }

    setSuggestedPending(true);

    try {
      await persistNewPhone(suggestedPhoneDigits);
      message({ type: 'success', text: 'Номер телефона добавлен' });
    } catch (error) {
      message({ type: 'error' });
    } finally {
      setSuggestedPending(false);
    }
  };

  return {
    suggestedPhoneDigits,
    showSuggestedPhone,
    suggestedPending,
    addSuggestedPhone,
  };
};
